<template lang="pug">
  #WtBadge
    BTooltip(position="is-top" multilined)
      BImage(:src="badge.badge.imageUrl" :alt="badge.badge.name")
      template(v-slot:content)
        p.badge-data
          strong {{ badge.badge.name }}
          br
          i Received on {{ badgeIssueDate }}
          br
          span {{ badge.badge.description }}
    .details(v-if="detailed")
      .badge-description {{ badge.badge.name }}
      .badge-date {{ badgeIssueDate }}

</template>

<script>
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "WtBadge",

  mixins: [dateUtilityMixin],

  props: {
    badge: {
      type: Object,
      required: true
    },
    detailed: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    badgeIssueDate() {
      return this.date(this.badge.issueDate, "DATE_FORMAT_FULL_MONTH")
        .formatted;
    }
  }
};
</script>

<style lang="sass" scoped>
.badge-data, .badge-data p
  min-width: 100px
  text-align: left
.badge-description
  font-family: $family-sans-serif-bold
  font-size: $size-5
.badge-date
  font-family: $family-sans-serif
  font-size: $size-7
</style>
